// v10/src/components/common/UpdateNotifier.js
//
// Escucha el evento `condor360:update-available` que dispara
// serviceWorkerRegistration.js cuando hay una nueva versión del SW en
// estado "waiting". Cuando lo recibe, muestra un toast persistente con
// botón "Actualizar" que, al clickearse, activa el SW nuevo y recarga
// la app.
//
// Este componente no renderiza nada visible — toda la UI vive en el toast.
// Hay que montarlo DENTRO del <ToastProvider> para que useToast() funcione.

import { useEffect, useContext } from 'react';
import * as Sentry from '@sentry/react';
import { ToastContext } from './ToastProvider';

export default function UpdateNotifier() {
  const toast = useContext(ToastContext);

  useEffect(() => {
    if (!toast) return undefined;

    const handler = (event) => {
      const applyUpdate = event.detail?.applyUpdate;
      if (typeof applyUpdate !== 'function') return;

      toast.show(
        'Hay una nueva versión disponible.',
        'info',
        null, // persistente hasta que el usuario actúe o cierre
        {
          label: 'Actualizar',
          onClick: applyUpdate,
        }
      );

      // Telemetría: registrar que el toast se mostró efectivamente al usuario.
      // No cambia comportamiento; solo permite medir si la detección llega
      // hasta el render del toast.
      try {
        Sentry.captureMessage('sw_update_shown', {
          level: 'info',
          tags: { sw_update: 'shown' },
        });
      } catch (_) { /* no-op */ }
    };

    window.addEventListener('condor360:update-available', handler);
    return () => window.removeEventListener('condor360:update-available', handler);
  }, [toast]);

  return null;
}
